<template>
  <svg
    width="720"
    height="1118"
    viewBox="0 0 720 1118"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.39319 64.5684C270.144 -40.0019 748.836 -200.477 537.6 -5.81605C273.554 237.51 -21.9663 651.22 437.907 500.184C897.781 349.148 681.34 715.479 437.907 1128.95"
      stroke="#462170"
      stroke-width="25"
    />
  </svg>
</template>
